import { BASE_URL } from '../utils/constant';
import { localStore } from '../App';

class DocksService 
{


  async fetchDocks(): Promise<any> 
  {
    const storageDocks = await this.fetchDocksFromStorage();
    if (storageDocks) 
    {
      console.log('fetchDocks:: Informazioni sugli attracchi presenti in memoria.');
      return storageDocks;
    }

    const remoteDocks = await this.fetchRemoteDocks();
    if (remoteDocks) 
    {
      console.log('fetchDocks:: Informazioni sugli attracchi scaricarte dal server.');
      return remoteDocks;
    }
    return null;
  }


  async fetchDocksFromStorage(): Promise<any> 
  {
    try 
    {
      console.log('fetchDocksFromStorage:: cerco informazioni sugli attracchi in memoria');
      const docks = await localStore.get("dockslist");
      if (docks != null) 
      {
        console.log('fetchDocksFromStorage:: Informazioni sugli attracchi presenti in memoria.');
        return docks;
      }

      console.log('Non sono presenti informazioni sugli attracchi in memoria - riavviare l\'app e  riprovare');
      return null;
    }
    catch (error) 
    {
      console.log('Problema nella ricezione dei dati sugli attracchi - riavviare l\'app e riprovare ', error);
      throw error;
    }
  }


  
  async fetchRemoteDocks(): Promise<[any] | null> 
  {
    console.log('fetchRemoteDocks:: cerco attracchi sul server');
    return new Promise((resolve, reject) => {
      const url = `${BASE_URL}/poServer.php?act=1&h=gkzLoFk0MN58TGqCJj`;
      fetch(url)
        .then(res => res.json())
        .then(
          (result) => 
          {
            console.log('Informazioni sugli attracchi scaricarte dal server.');
            localStore.set('dockslist', result.content);
            resolve(result.content);
          },
          (error) => {
            console.log('Problema nella ricezione dei dati sugli attracchi - controlliamo se ce ne sono in memoria ', error);
            resolve(null);
          }
        );
    });
  }
}

export default DocksService; 